module.exports = __webpack_public_path__ + "static/media/blink-eye-open.f9a26b0f.png";